const template = require('./suggestions.tpl').default;

module.exports = DomClass(template, function() {
	var _t = this;
	var hoverIndex = null;

	this.down = function() {
		if (hoverIndex == null) {
			hoverIndex = 0;
		} else {
			hoverIndex = Math.min(hoverIndex + 1, this.items.length - 1);
		}
		this.refresh();
		return this.items[hoverIndex] || '';
	};

	this.up = function() {
		if (hoverIndex == null) {
			hoverIndex = this.items.length - 1;
		} else {
			hoverIndex = Math.max(hoverIndex - 1, 0);
		}
		this.refresh();
		return this.items[hoverIndex] || '';
	};

	this.refresh = function() {
		var items = this.items.forEach ? this.items : [];
		items.forEach(function(item, index) {
			if (index == hoverIndex) {
				item.classList.add('active');
			} else {
				item.classList.remove('active');
			}
		});

		if (this.next) {
			this.pager.classList.add('active');
		} else {
			this.pager.classList.remove('active');
		}
	};

	if (isa(this.items, Array)) {
		this.items.forEach(function(item, index) {
			item.onclick = function(evt) {
				// (evt || window.event).preventDefault();
				on(_t, 'select').fire(item);
				// return false;
			};
		});
	}

	this.refresh();
});
